import $ from "jquery";

/**
 * Direct booking checkout events from the Valantic measurement plan (GA4, August 2026).
 *
 *   add_to_cart           a bookable date on the trip page (calendar or list)
 *   begin_checkout ...    arriving on a page of the booking form; the server describes the
 *   add_traveler_details  checkout on the <form> tag (lib/wp/datalayer-checkout.php)
 *
 * to_payment and purchase are server-confirmed and pushed by tracking.js. Every step counts
 * once per checkout, also when the visitor goes back and forth: the pushed steps are kept
 * per trip in sessionStorage and cleared by the purchase.
 */

const STORAGE_PREFIX = "sb_checkout_";

const readSteps = (checkoutId) => {
    try {
        return JSON.parse(window.sessionStorage.getItem(STORAGE_PREFIX + checkoutId)) || [];
    } catch (e) {
        return [];
    }
};

const saveSteps = (checkoutId, steps) => {
    try {
        window.sessionStorage.setItem(STORAGE_PREFIX + checkoutId, JSON.stringify(steps));
    } catch (e) {
        // Without storage a step can count twice; the push itself still happens.
    }
};

const SbClearCheckout = (checkoutId) => {
    try {
        window.sessionStorage.removeItem(STORAGE_PREFIX + checkoutId);
    } catch (e) {
        // Nothing to clear.
    }
};

window.SbClearCheckout = SbClearCheckout;

const parseJson = (value) => {
    try {
        return JSON.parse(value);
    } catch (e) {
        return null;
    }
};

/**
 * begin_checkout ... add_traveler_details: the event for the page this render shows.
 */
const pushStep = (form) => {
    const $form = $(form);
    const checkout = parseJson($form.attr("data-sb-checkout"));
    const events = parseJson($form.attr("data-sb-checkout-events")) || {};
    const checkoutId = $form.attr("data-sb-checkout-id");
    const formId = $form.attr("data-sb-form-id");
    const page = parseInt($form.find(`input[name="gform_source_page_number_${formId}"]`).val(), 10) || 1;
    const event = events[page];

    if (!checkout || !checkoutId || !event) {
        return;
    }

    const steps = readSteps(checkoutId);
    if (steps.includes(event)) {
        return;
    }

    saveSteps(checkoutId, [...steps, event]);
    window.SbPushEcommerceEvent(event, checkout);
};

/**
 * add_to_cart with add_type directbooking: a date link to the booking form on the trip page.
 * The flight's date and price come from the calendar data the links are rendered from.
 */
const rtfFromCalendar = ($calendar, rtfId) => {
    const byDate = parseJson($calendar.attr("data-rtf-data"))?.rtfs_by_date || {};

    for (const [date, rtfs] of Object.entries(byDate)) {
        const rtf = [].concat(rtfs).find((candidate) => String(candidate.rtf_id) === String(rtfId));
        if (rtf) {
            return { date, price: parseFloat(rtf.price) || 0 };
        }
    }

    return null;
};

$(document).on("click", "[data-rtf-calendar] a[href*='rtf-id']", function () {
    if (!window.SbPageItem) {
        return;
    }

    const rtfId = new URLSearchParams(($(this).attr("href") || "").split("?")[1] || "").get("rtf-id");
    const rtf = rtfFromCalendar($(this).closest("[data-rtf-calendar]"), rtfId);
    const item = { ...window.SbPageItem };

    if (rtf) {
        // YYYY-MM-DD -> DD-MM-YYYY, the plan's date format.
        item.departure = rtf.date.split("-").reverse().join("-");
        if (rtf.price) {
            item.price = rtf.price;
        }
    }

    window.SbPushEcommerceEvent("add_to_cart", {
        currency: item.currency,
        add_type: "directbooking",
        value: (item.price || 0) * (item.quantity || 1),
        items: [item],
    });
});

const init = () => {
    $("form[data-sb-checkout]").each(function () {
        pushStep(this);
    });
};

$(init);
